import React, { useState, useEffect } from 'react';
import { 
  CContainer, CRow, CCol, CButton, CCard, CCardBody, CBadge 
} from '@coreui/react';

import { useNavigate , useLocation} from 'react-router-dom';
import bannerImage from '../../assets/images/bannerImage.png';
import api from '../../api/axiosInstance';
import { BASE_API_URL } from '../../config/apiConfig';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const navigate = useNavigate();
    const location = useLocation(); 
  const [categories, setCategories] = useState([]);
  const [categoriesBeeta, setCategoriesBeeta] = useState([]);
  const [categoriesBeetaOther, setCategoriesBeetaOther] = useState([]);
  const [categoriesGamma, setCategoriesGamma] = useState([]);
  const [categoriesGammaOther, setCategoriesGammaOther] = useState([]);
  const [categoriesDeltaOlympiad, setCategoriesDeltaOlympiad] = useState([]);
  const [categoriesDeltaJEE, setCategoriesDeltaJEE] = useState([]);
  const [categoriesDeltaOther, setCategoriesDeltaOther] = useState([]);

  // Courses config
  const courses = [
    { id: 'alpha', name: 'Alpha', color: '#FF5733', symbol: 'α', type: 'FREE' },
    { id: 'beeta', name: 'Beeta', color: '#33FF57', symbol: 'β', type: 'PREMIUM' },
    { id: 'gamma', name: 'Gamma', color: '#3357FF', symbol: 'γ', type: 'PREMIUM' },
    { id: 'delta', name: 'Delta', color: '#F333FF', symbol: 'δ', type: 'PREMIUM' },
    { id: 'sigma', name: 'Sigma', color: '#FFBD33', symbol: 'Σ', type: 'PREMIUM' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const [seoData, setSeoData] = useState({
    metaTitle: '',
    metaKeywords: '',
    metaDescription: ''
  });
   useEffect(() => {
      const fetchSeoData = async () => {
        try {
          // Current full URL ya pathname pass karein
          const currentPath = window.location.href; // "https://ambipie.com/course/alpha" ya location.pathname
          
          const res = await api.get(`/api/seo/GetSeoByUrl?pageUrl=${encodeURIComponent(currentPath)}`, { skipAuthCheck: true });
          
          if (res.data) {
            setSeoData({
              metaTitle: res.data.metaTitle || res.data.MetaTitle,
              metaKeywords: res.data.metaKeywords || res.data.MetaKeywords,
              metaDescription: res.data.metaDescription || res.data.MetaDescription,
            });
  
           
          }
        } catch (err) {
          console.error("SEO Data Error:", err);
        }
      };
  
      fetchSeoData();
    }, [location.pathname]);
  
  const handleCourseAccess = (section, title) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate(`/${section}/${title.replace(/\s+/g, '')}`);
    } else {
      navigate('/login'); 
    }
  };

  // 🚀 SINGLE API CALL FUNCTION FOR ALL CATEGORIES
  useEffect(() => {
    const fetchAllCategories = async () => {
      try {
        const res = await api.get('/api/admin/GetAllCategories', { skipAuthCheck: true });
        const allData = res.data || [];

        // Single pass filtering
        setCategories(allData.filter(cat => cat.section === 'Alpha'));
        setCategoriesBeeta(allData.filter(cat => cat.section === 'Beeta'));
        setCategoriesBeetaOther(allData.filter(cat => cat.section === 'BeetaOther'));
        setCategoriesGamma(allData.filter(cat => cat.section === 'Gamma'));
        setCategoriesGammaOther(allData.filter(cat => cat.section === 'GammaOther'));
        setCategoriesDeltaOlympiad(allData.filter(cat => cat.section === 'DeltaOlympiad'));
        setCategoriesDeltaJEE(allData.filter(cat => cat.section === 'DeltaJEE'));
        setCategoriesDeltaOther(allData.filter(cat => cat.section === 'DeltaOther'));
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    fetchAllCategories();
  }, []);

  return (
         <>{/* 🚀 Dynamic Meta Tags Injection */}
              <Helmet>
                <title>{seoData.metaTitle || "AmbiPie - Online Courses"}</title>
                <meta name="title" content={seoData.metaTitle} />
                <meta name="description" content={seoData.metaDescription} />
                <meta name="keywords" content={seoData.metaKeywords} />
              </Helmet>
    <div className="pb-5 bg-white">
      {/* Hero Section */}
      <div style={{ backgroundColor: '#0056b3', color: 'white', padding: '80px 0' }}>
        <CContainer>
          <CRow className="align-items-center">
            <CCol md={7} lg={6} className="text-md-start text-center mb-5 mb-md-0">
              <h1 className="display-5 fw-bold mb-3 text-white" style={{ lineHeight: '1.2' }}>
                Exams PYQs / <br className="d-none d-lg-block" /> Books Solutions / Notes
              </h1>
              <p className="lead mb-4" style={{ fontSize: '1.25rem', opacity: '0.9' }}>
                by AMBIPI (एम्बीपाई)
              </p>
              <CButton 
                color="warning" 
                size="lg" 
                className="fw-bold px-5 text-dark shadow-lg"
                onClick={() => navigate('/all-access')}
                style={{ borderRadius: '50px', transition: '0.3s' }}
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                Get PYQs | Solutions | Notes
              </CButton>
            </CCol>

            <CCol md={5} lg={6} className="text-center">
              <img 
                src={bannerImage}
                alt="Mathematics Education Illustration" 
                className="img-fluid"
                style={{ 
                  maxHeight: '400px',
                  padding: '10px',
                  backgroundColor: 'white',
                  border: '1px solid #dee2e6',
                  borderRadius: '20px',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.2), 0 10px 20px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease',
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-10px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
              />
            </CCol>
          </CRow>
        </CContainer>
      </div>

      <CContainer className="mt-5">
        <h3 className="text-center mb-5 fw-bold">Select Your Mathematics Course</h3>
        <CRow className="justify-content-center text-center mb-5">
          {courses.map((c) => (
            <CCol key={c.id} xs={4} md={2} className="mb-4">
              <div 
                onClick={() => scrollToSection(c.id)}
                className="rounded-circle shadow mx-auto d-flex align-items-center justify-content-center text-white fw-bold"
                style={{ 
                    width: '90px', height: '90px', backgroundColor: c.color, 
                    cursor: 'pointer', fontSize: '2.2rem', transition: '0.3s' 
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {c.symbol}
              </div>
              <p className="mt-2 fw-bold text-uppercase">{c.name}</p>
            </CCol>
          ))}
        </CRow>

        {/* Detailed Sections */}
        {courses.map((course) => (
          <div key={course.id} id={course.id} className="pt-5 mt-5 border-top">
            <div className="d-flex align-items-center mb-4">
               <h2 className="fw-bold text-dark me-3">{course.name} Section</h2>
               <CBadge color={course.type === 'FREE' ? 'success' : 'info'}>{course.type}</CBadge>
            </div>
            
            <CRow>
              {/* Alpha Specific Content */}
              {course.id === 'alpha' && (
                <CCol md={12} className="mb-4">
                  <CCard className="border-0 bg-light shadow-sm">
                    <CCardBody className="p-4">
                      <h5 className="fw-bold text-success mb-3">Alpha: Free Access</h5>
                      <p className="mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                        <strong>Questions Bank of Important and Tricky Questions with Solutions.</strong><br/>
                        These questions are of: Schools Level, Olympiad Level, JEE Level, 
                        SAT/ACT/AP Exams Level, Common Core Level, Puzzles Levels etc.
                      </p>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}

              {/* Alpha Detailed Grid */}
              {course.id === 'alpha' && (
                <div className="mt-4">
                  <div className="bg-warning text-center py-2 mb-1 fw-bold">
                    Alpha: FREE 
                  </div>
                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Questions Bank with Solutions (Uploaded Daily on Social Media Account as Facebook, Instagram, LinkedIn, YouTube etc.) 
                  </div>

                  <CRow className="g-4">
                    {categories.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ 
                                width: '100%', 
                                height: '200px', 
                                objectFit: 'cover',
                                display: 'block'
                              }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)} 
                          >
                           {item.buttonText}
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>

                  <div className="text-center mt-5">
                    <CButton 
                      variant="outline" 
                      color="danger" 
                      className="px-5 py-2 fw-bold"
                      style={{ borderRadius: '0', borderWidth: '2px' }}
                      onClick={()=>navigate('/course/alpha')}
                    >
                      View All Alpha Notes
                    </CButton>
                  </div>
                </div>
              )}

              {/* Beeta Specific Content */}
              {course.id === 'beeta' && (
                <CCol md={12} className="mb-4">
                  <CCard className="border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
                    <CCardBody className="p-4">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="fw-bold text-primary mb-2">Beeta: Algebra Mastery Pack</h5>
                          <p className="mb-3" style={{ fontSize: '1.05rem', color: '#444' }}>
                            <strong>Advanced Question Bank & Concept Notes</strong><br/>
                            Algebra fundamentals to advanced level questions for JEE, SAT, and Olympiads. 
                            Includes step-by-step video hints and downloadable worksheets.
                          </p>
                        </div>
                        <div className="text-end">
                          <h3 className="fw-bold text-dark mb-0">₹999</h3>
                          <p className="text-muted small">One-time payment</p>
                        </div>
                      </div>

                      <CRow className="mt-3 g-3">
                        <CCol md={8}>
                          <div className="p-2 bg-white rounded border mb-2 mb-md-0">
                            <small className="text-muted d-block">Key Highlights:</small>
                            <span className="me-2">✅ 500+ Tricky Questions</span>
                            <span className="me-2">✅ Live Doubt Support</span>
                          </div>
                        </CCol>
                        <CCol md={4}>
                          <CButton 
                            color="danger" 
                            className="w-100 fw-bold py-2 shadow-sm"
                            onClick={() => navigate('/payment/beeta')}
                          >
                            🛒 Buy Now: Full Access
                          </CButton>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}

              {/* Beeta Detailed Grids */}
              {course.id === 'beeta' && (
                <div className="mt-4">
                  <div className="bg-warning text-center py-2 mb-1 fw-bold">
                    Beeta: PYQs 
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Previous Year Questions Bank with Solutions of Competitive Exams conducting in <span className="text-warning">INDIA</span>
                  </div>

                  <CRow className="g-4 mb-4">
                    {categoriesBeeta.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mb-5">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0' }}
                   onClick={()=>navigate(`/course/${course.id}`)}
                    >
                      View All INDIAN Exams PYQs
                    </CButton>
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Previous Year Questions Bank with Solutions of Competitive Exams conducting in <span className="text-warning">US/UK/Other</span>
                  </div>

                  <CRow className="g-4">
                    {categoriesBeetaOther.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                             onClick={() => handleCourseAccess(item.section, item.title)}
                            
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mt-3">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0' }}
                     onClick={()=>navigate(`/course/${course.id}`)}
                    >
                      View All US/UK Exams PYQs
                    </CButton>
                  </div>
                </div>
              )}

              {/* Gamma Specific Content */}
              {course.id === 'gamma' && (
                <CCol md={12} className="mb-4">
                  <CCard className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #e0f7fa 0%, #80deea 100%)', borderRadius: '15px' }}>
                    <CCardBody className="p-4">
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div style={{ flex: '1', minWidth: '300px' }}>
                          <h4 className="fw-bold text-dark mb-2">Gamma: Calculus Advanced Bundle</h4>
                          <p className="mb-3" style={{ fontSize: '1.1rem', color: '#006064' }}>
                            <strong>Master Derivatives & Integrals</strong><br/>
                            Exclusive access to high-level Calculus notes, solved PYQs for AP Calculus AB/BC, 
                            and advanced practice sets for JEE Advanced.
                          </p>
                          <div className="mb-3">
                            <CBadge color="dark" className="me-2">Full Syllabus</CBadge>
                            <CBadge color="dark" className="me-2">Video Hints</CBadge>
                            <CBadge color="dark">24/7 Support</CBadge>
                          </div>
                        </div>
                        <div className="text-center p-3 bg-white rounded shadow-sm" style={{ minWidth: '150px' }}>
                          <h2 className="fw-bold text-primary mb-0">₹1499</h2>
                          <p className="text-muted small mb-2">Lifetime Access</p>
                          <CButton 
                            color="info" 
                            className="fw-bold text-white w-100 shadow"
                            onClick={() => navigate('/payment/gamma')}
                          >
                            Unlock Gamma
                          </CButton>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}

              {/* Gamma Detailed Grids */}
              {course.id === 'gamma' && (
                <div className="mt-4">
                  <div className="bg-warning text-center py-2 mb-1 fw-bold border border-dark">
                    Gamma: Book Solutions 
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Solutions of Questions of Various TextBooks/Olympiad of Schools in <span className="text-warning">INDIA</span>
                  </div>

                  <CRow className="g-4 mb-4">
                    {categoriesGamma.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mb-5">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0', border: '1px solid red' }}
                     onClick={()=>navigate(`/course/${course.id}`)}>
                      View All INDIA TextBooks
                    </CButton>
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Solutions of Questions of Various TextBooks/Olympiad of Schools in <span className="text-warning">US/UK</span>
                  </div>

                  <CRow className="g-4 mb-4">
                    {categoriesGammaOther.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mt-3">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0', border: '1px solid red' }}
                     onClick={()=>navigate(`/course/${course.id}`)}>
                      View All US/UK TextBooks
                    </CButton>
                  </div>
                </div>
              )}

              {/* Delta Specific Content */}
              {course.id === 'delta' && (
                <CCol md={12} className="mb-4">
                  <CCard className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #fff9c4 0%, #fbc02d 100%)', borderRadius: '15px' }}>
                    <CCardBody className="p-4">
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div style={{ flex: '1', minWidth: '300px' }}>
                          <h4 className="fw-bold text-dark mb-2">Delta: Mathematics Notes</h4>
                          <p className="mb-3" style={{ fontSize: '1.1rem', color: '#5f4b00', lineHeight: '1.6' }}>
                            <strong>Get Mathematics Notes of All chapters topic-wise with practice questions.</strong><br/>
                            Which helps you a lot in the preparation of any competitive exams and understand the concepts in depth.
                          </p>
                          <div className="mb-3">
                            <CBadge color="dark" className="me-2">Topic-wise</CBadge>
                            <CBadge color="dark" className="me-2">Competitive Exams</CBadge>
                            <CBadge color="dark">In-depth Concepts</CBadge>
                          </div>
                        </div>
                        <div className="text-center p-3 bg-white rounded shadow-sm" style={{ minWidth: '150px' }}>
                          <h2 className="fw-bold text-warning mb-0">₹799</h2>
                          <p className="text-muted small mb-2">Lifetime Access</p>
                          <CButton 
                            color="warning" 
                            className="fw-bold text-dark w-100 shadow"
                            onClick={() => navigate('/payment/delta')}
                          >
                            Get Delta Notes
                          </CButton>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}

              {/* Delta Detailed Grids */}
              {course.id === 'delta' && (
                <div className="mt-4">
                  <div className="bg-warning text-center py-2 mb-1 fw-bold border border-dark">
                    Delta: Notes 
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Get full NOTES of Mathematics Concepts of <span className="text-warning">Olympiad (Grade/Class 8, 9, 10)</span>
                  </div>
                  <CRow className="g-4 mb-4">
                    {categoriesDeltaOlympiad.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mb-5">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0', border: '2px solid red' }}
                     onClick={()=>navigate(`/course/${course.id}`)}>
                      View All 8/9/10 Maths Notes
                    </CButton>
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Get full NOTES of Mathematics Concepts of <span className="text-warning">JEE (Grade/Class 11, 12)</span>
                  </div>
                  <CRow className="g-4 mb-4">
                    {categoriesDeltaJEE.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mb-5">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0', border: '2px solid red' }}
                     onClick={()=>navigate(`/course/${course.id}`)}>
                      View All 11/12 Maths Notes
                    </CButton>
                  </div>

                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '0.9rem' }}>
                    Get full NOTES of Mathematics Concepts of <span className="text-warning">SAT/AP/ACT/CommonCoreSyllabus</span>
                  </div>
                  <CRow className="g-4 mb-4">
                    {categoriesDeltaOther.map((item, idx) => (
                      <CCol md={4} sm={6} key={idx}>
                        <div className="border border-dark text-center bg-white shadow-sm h-100" 
                             style={{ borderRadius: '15px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <div className="border-bottom border-dark py-2 fw-bold bg-light text-dark">
                            {item.title}
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden', height: '100px', backgroundColor: '#f0f0f0' }}>
                            <LazyLoadImage
                              alt={item.title}
                              effect="blur"
                              src={`${BASE_API_URL}${item.imagePath}`}
                              wrapperProps={{
                                  style: { transitionDelay: "1s", height: '100%', width: '100%', display: 'block' },
                              }}
                              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                              placeholderSrc="https://placehold.co/400x100?text=Loading..." 
                            />
                          </div>
                          <div 
                            className="border-top border-dark py-2 fw-bold" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', transition: '0.3s' }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onClick={() => handleCourseAccess(item.section, item.title)}
                          >
                            Get Questions Bank
                          </div>
                        </div>
                      </CCol>
                    ))}
                  </CRow>
                  <div className="text-center mt-3">
                    <CButton variant="outline" color="danger" className="px-4 fw-bold" style={{ borderRadius: '0', border: '2px solid red' }}
                     onClick={()=>navigate(`/course/${course.id}`)}>
                      View All US/UK Maths Notes
                    </CButton>
                  </div>
                </div>
              )}

              {/* Sigma Specific Content */}
              {course.id === 'sigma' && (
                <CCol md={12} className="mb-4">
                  <CCard className="border-0 shadow-lg text-white" style={{ background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)', borderRadius: '15px' }}>
                    <CCardBody className="p-4">
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div style={{ flex: '1', minWidth: '300px' }}>
                          <h4 className="fw-bold mb-2 text-warning">Sigma: All Access Membership</h4>
                          <p className="mb-3" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                            <strong>Get the access of all course content in just a single subscription.</strong><br/>
                            Whether you are preparing for any exams, need any solutions from your TextBooks, 
                            or want to know the full depth of any concepts.
                          </p>
                          <div className="d-inline-block p-2 px-3 bg-white text-dark rounded border border-2 fw-bold mb-3" style={{ fontSize: '1.3rem' }}>
                            Σ = α + β + γ + δ
                          </div>
                        </div>
                        <div className="text-center p-3 bg-white rounded shadow-sm" style={{ minWidth: '180px' }}>
                          <h2 className="fw-bold text-primary mb-0">₹2499</h2>
                          <p className="text-muted small mb-2">Best Value Pack</p>
                          <CButton 
                            color="danger" 
                            className="fw-bold w-100 shadow py-2"
                            onClick={() => navigate('/payment/sigma')}
                          >
                            🚀 Buy All Access
                          </CButton>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}

              {/* Sigma Detailed Layout */}
              {course.id === 'sigma' && (
                <div className="mt-4">
                  <div className="bg-warning text-center py-2 mb-1 fw-bold border border-dark">
                    Sigma: All 
                  </div>
                  <div className="text-white text-center py-2 mb-4 fw-bold" style={{ backgroundColor: '#002147', fontSize: '1rem' }}>
                    For Parent or Teacher: <span className="text-warning">Get All Access</span>
                  </div>

                  <div className="d-flex align-items-center justify-content-center flex-wrap mb-4 bg-white p-4 border shadow-sm">
                    <div className="text-center border border-dark p-2 mx-1" style={{ width: '120px' }}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white mx-auto mb-1" style={{ width: '60px', height: '60px', fontSize: '1.5rem', backgroundColor: '#002147' }}>α</div>
                      <small className="fw-bold">Alpha</small>
                    </div>
                    <div className="display-6 fw-bold text-danger mx-2">+</div>

                    <div className="text-center border border-dark p-2 mx-1" style={{ width: '120px' }}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white mx-auto mb-1" style={{ width: '60px', height: '60px', fontSize: '1.5rem', backgroundColor: '#002147' }}>β</div>
                      <small className="fw-bold">Beeta</small>
                    </div>
                    <div className="display-6 fw-bold text-danger mx-2">+</div>

                    <div className="text-center border border-dark p-2 mx-1" style={{ width: '120px' }}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white mx-auto mb-1" style={{ width: '60px', height: '60px', fontSize: '1.5rem', backgroundColor: '#002147' }}>γ</div>
                      <small className="fw-bold">Gamma</small>
                    </div>
                    <div className="display-6 fw-bold text-danger mx-2">+</div>

                    <div className="text-center border border-dark p-2 mx-1" style={{ width: '120px' }}>
                      <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white mx-auto mb-1" style={{ width: '60px', height: '60px', fontSize: '1.5rem', backgroundColor: '#002147' }}>δ</div>
                      <small className="fw-bold">Delta</small>
                    </div>
                    <div className="display-6 fw-bold text-danger mx-2">=</div>

                    <div className="text-center border border-dark p-2 mx-1" style={{ width: '120px' }}>
                      <div className="d-flex align-items-center justify-content-center border border-dark mx-auto mb-1" style={{ width: '60px', height: '60px', backgroundColor: '#002147' }}>
                          <span className="text-white fw-bold" style={{ fontSize: '1.5rem', border: '2px solid white', padding: '0 5px' }}>Σ</span>
                      </div>
                      <small className="fw-bold">Sigma</small>
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <CButton 
                      variant="outline" 
                      color="danger" 
                      className="px-5 py-2 fw-bold"
                      style={{ borderRadius: '0', border: '2px solid red', color: 'red' }}
                      onClick={() => navigate('/payment/sigma')}
                    >
                      Get All Access
                    </CButton>
                  </div>
                </div>
              )}
           
            </CRow>
          </div>
        ))}

        {/* Quick Links Footer */}
        <div className="mt-5 pt-5 text-center border-top">
           <p className="text-muted">
             <strong>Quick Links:</strong> 
             {courses.map(c => <span key={c.id} className="mx-2" style={{cursor:'pointer'}} onClick={()=>scrollToSection(c.id)}>{c.name}</span>)}
           </p>
        </div>
      </CContainer>
    </div>
    </>
  );
};

export default Home;